import { Formik } from 'formik';
import React, { useMemo } from 'react';
import { Form } from 'react-bootstrap';

import { PrimaryButton } from '@components/Button/variants';
import Divider from '@components/Divider';
import TextField from '@components/Form/TextField';
import { useProfileUpdate } from '@hooks';

import SocialSchema from './SocialSchema';

const removeSpaces = (string) => string.replace(/\s/g, '');

interface ProfileProps {
  instagram: string;
  isDisabled?: boolean;
  linkedin: string;
  personalUrl: string;
  twitter: string;
  userId: number;
}

const Profile = ({
  userId,
  twitter,
  linkedin,
  instagram,
  personalUrl,
  isDisabled,
}: ProfileProps) => {
  const initialState = useMemo(
    () => ({
      twitter: twitter || '',
      linkedin: linkedin || '',
      instagram: instagram || '',
      personalUrl: personalUrl || '',
    }),
    [twitter, linkedin, instagram, personalUrl]
  );
  const { saveProfile, isSavingProfile, showSave } = useProfileUpdate({ userId });

  const handleSubmit = (values) => {
    const sanitizedParams = {
      twitter: removeSpaces(values.twitter),
      linkedin: removeSpaces(values.linkedin),
      instagram: removeSpaces(values.instagram),
      personal_url: removeSpaces(values.personalUrl),
    };

    saveProfile(sanitizedParams);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialState}
      onSubmit={handleSubmit}
      validationSchema={SocialSchema}
    >
      {(formik) => (
        <Form noValidate onSubmit={formik.handleSubmit}>
          <div className="section-container" id="Social">
            <div className="section-header mt-2">Social</div>
            <div className="section-detail mb-48">
              <div className="section-detail-container mb-24">
                <div className="section-description">
                  <div>Where can we find you online?</div>
                </div>
              </div>
              <div className="section-form-container">
                <TextField
                  className="mb-24"
                  name="personalUrl"
                  label="Website"
                  placeholder="https://"
                  disabled={isDisabled}
                />
                <TextField
                  className="mb-24"
                  name="linkedin"
                  label="LinkedIn"
                  preset="@"
                  placeholder="handle"
                  disabled={isDisabled}
                />
                <TextField
                  className="mb-24"
                  name="twitter"
                  label="Twitter"
                  preset="@"
                  placeholder="handle"
                  disabled={isDisabled}
                />
                <TextField
                  className="mb-24"
                  name="instagram"
                  label="Instagram"
                  preset="@"
                  placeholder="handle"
                  disabled={isDisabled}
                />
              </div>
            </div>
            <div className="save-action-container" id="social-save">
              <PrimaryButton
                as="button"
                disabled={!(formik.isValid && formik.dirty) || isDisabled || isSavingProfile}
                type="submit"
              >
                {showSave ? 'Saved' : 'Save'}
              </PrimaryButton>
            </div>
            <Divider />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default Profile;
